import React, { Component } from 'react'
import Slider from 'react-slick'

import '../../css/main-components/carrousel.css'

function SampleNextArrow(props) {
	const {className, style, onClick} = props
	return (
		<div
			className={className}
			style = {{...style, 
				backgroundImage: 'url(../../img/resources/FLECHA-D.png)',
				backgroundSize: 'cover',
				right: '1%',
				height: '30px',
				width: '28px',
			}}
			onClick = {onClick}
		></div>
	);
}

function SamplePrevArrow(props) {
	const {className, style, onClick} = props
	return (
		<div
			className={className}
			style = {{...style,
				backgroundImage: 'url(../../img/resources/FLECHA-I.png)',
				backgroundSize: 'cover',
				left: '1%',
				height: '30px',
				width: '28px',
				zIndex: '8'
			}}
			onClick={onClick}
		></div>
	);
}

export default class Carrousel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			section: props.section
		};
	}
	
	render() {
		var settings = {
			autoplay:true,
			autoplaySpeed:2700,
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />
		};
		var carrouselLength = [1,2,3,4,5];
		return (
		<div id="carrousel">
			<Slider {...settings}>
				{
					carrouselLength.map(( i ) => (
						<img 
							key={i}
							src={`../../img/${this.state.section}/0${i}.jpg`}
							alt="carrousel"
						/>
					))
				}
			</Slider>
		</div>
	)}
}
/*
<img 
	src={`../../img/test/${this.state.section}/IMP01.jpg`}
	alt="carrousel"
/>
*/


// WEBPACK FOOTER //
// ./src/components/main-components/carrousel.js